import classnames from 'classnames'
import React, { ReactNode, useEffect, useRef } from 'react'

// Utils

// Dependencies
import removeTargetAttributeForHashAnchorTags from '@src/quince-site-common/src/utils/removeTargetAttributeForHashAnchorTags'
import { isEmpty } from '@src/utils/functions/utils'

import ProductDetailsIcon, { ProductDetailsIconProps } from '../productDetailsIcon'

// Styles
import styles from './productDetails.module.scss'

export interface ProductDetailsProps {
  textContent: ReactNode
  icons?: ProductDetailsIconProps[]
  className?: string
  shadowClassName?: string
}

const ProductDetails = ({ textContent, icons, className, shadowClassName }: ProductDetailsProps) => {
  const classes = classnames(className, styles.productDetails)
  const productDetailsDivWrapper = useRef<HTMLDivElement>(null)
  useEffect(() => {
    removeTargetAttributeForHashAnchorTags(productDetailsDivWrapper.current)
  }, [])

  return (
    <div className={classes} ref={productDetailsDivWrapper}>
      <div className={styles.productDetails__textContent}>{textContent}</div>
      {!isEmpty(icons as any) && (
        <div className={styles.productDetails__iconsContainer}>
          {icons?.map(icon => (
            <ProductDetailsIcon key={icon.displayTitle} displayTitle={icon.displayTitle} image={icon.image} />
          ))}
        </div>
      )}
      <div className={shadowClassName}></div>
    </div>
  )
}

export default ProductDetails
